<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section" v-if="contentLoaded">
          <div class="z-card z-card--only-desktop">
            <z-icon :icon="['far', 'check-circle']" size="extra-large" color="success" />
            <div class="z-title z-title--small">
              Sua forma de pagamento foi alterada com sucesso
            </div>

            <p class="z-text spacer-bottom-l">
              A mensalidade
              <template v-if="nextAvailableBill">
                de <strong>{{ nextAvailableBill.month_name }}</strong>
              </template>
              <span v-if="isCard">
                será cobrada no seu {{ translatedPaymentMethod }}
                <strong>
                  <span class="card-brand">{{ currentCard.card_brand }}</span> de final {{ currentCard.last_digits }}
                </strong>.
              </span>
              <span v-else>
                já está disponível via <strong>{{ translatedPaymentMethod }}</strong>.
              </span>
            </p>

            <open-bill-alert :bill="currentBill" :card="currentCard" v-if="isCurrentBillForToday" />

            <router-link
              tag="button"
              :to="{ name: 'panel'}"
              class="z-button z-button--primary z-button--block"
              v-else
            >
              Voltar para página inicial
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.success-icon {
  margin-bottom: var(--space-medium);
}

.card-brand {
  text-transform: capitalize;
}

.z-card--only-desktop {
  @media (max-width: $screen-sm-max) {
    background-color: unset;
    box-shadow: unset;
    padding: unset;
    transition: unset;
  }
}
</style>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import DateUtils from 'utils/date-utils';
import OpenBillAlert from './open-bill-alert';

export default {
  components: {
    OpenBillAlert,
  },
  data() {
    return {
      contentLoaded: false,
    };
  },
  computed: {
    ...mapState([
      'currentBilling',
      'notPaidBills',
    ]),
    ...mapGetters([
      'translatedPaymentMethod',
    ]),
    isCard() {
      return ['credit_card'].includes(this.currentBilling.recurrent_payment_method);
    },
    currentCard() {
      return this.currentBilling.student_card;
    },
    currentBill() {
      return this.notPaidBills[0];
    },
    nextBill() {
      return this.notPaidBills[1];
    },
    isCurrentBillForToday() {
      return this.currentBill.due_date === DateUtils.currentDate();
    },
    nextAvailableBill() {
      if (this.isCurrentBillForToday) {
        return this.nextBill;
      }
      return this.currentBill;
    },
  },
  methods: {
    ...mapActions([
      'loadNotPaidBills',
      'loadBillings',
    ]),
  },
  mounted() {
    // reload billings with recurrent payment method updated
    this.loadBillings().then(() => {
      this.loadNotPaidBills().then(() => {
        this.contentLoaded = true;
        this.$tracker.logEvent(
          'Viewed payment method successfully changed page',
          {
            withBillPaymentSuggestion: this.isCurrentBillForToday,
            recurrentPaymentMethod: this.currentBilling.recurrent_payment_method,
          },
        );
      });
    });
  },
};
</script>
